import {
  useDataProvider,
  useGetIdentity,
  useListContext,
  useNotify,
  useRefresh,
  useUnselectAll,
} from "ra-core";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";

export const RemoveEmployeesButton = () => {
  const { selectedIds } = useListContext();
  const { identity } = useGetIdentity();
  const provider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const unselect = useUnselectAll("sales");
  const [open, setOpen] = useState(false);
  const [pending, setPending] = useState(false);
  return (
    <>
      <Button type="button" variant="destructive" onClick={() => setOpen(true)}>
        Удалить пользователей
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Удалить выбранные аккаунты?</DialogTitle>
          </DialogHeader>
          <p>
            Количество: {selectedIds.length}. Аккаунты входа будут удалены.
            Имена авторов в задачах, расходах и логах сохранятся. Удаление
            аккаунта нельзя отменить.
          </p>
          <DialogFooter>
            <Button
              type="button"
              variant="outline"
              disabled={pending}
              onClick={() => setOpen(false)}
            >
              Отмена
            </Button>
            <Button
              type="button"
              variant="destructive"
              disabled={pending}
              onClick={async () => {
                if (
                  selectedIds.some((id) => String(id) === String(identity?.id))
                ) {
                  notify(
                    "Снимите выделение со своего аккаунта администратора",
                    { type: "error" },
                  );
                  return;
                }
                setPending(true);
                try {
                  await provider.deleteMany("sales", { ids: selectedIds });
                  unselect();
                  setOpen(false);
                  notify("Аккаунты удалены", { type: "success" });
                } catch (error) {
                  notify((error as Error).message, { type: "error" });
                } finally {
                  setPending(false);
                  refresh();
                }
              }}
            >
              {pending ? "Удаление…" : "Удалить"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
